import Select from 'components/Select/Select'
import { TOption } from 'components/Select/types'
import { LABELS, PLACEHOLDERS } from 'constants/txt'

type PeriodSelectProps = {
  options: TOption[]
  value?: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const PeriodSelect = ({
  options,
  value,
  onChange,
  disabled = false
}: PeriodSelectProps) => (
  <Select
    options={options}
    className="tiered-hospitals-section__select"
    propsItem={{
      label: LABELS.PERIOD,
      tooltip: ''
    }}
    propsSelect={{
      value,
      placeholder: PLACEHOLDERS.PLEASE_SELECT,
      onChange: (next) => onChange(String(next)),
      disabled: disabled || !options.length
    }}
  />
)
